import Vue from 'vue'
import Vuex from 'vuex'

import {
  getRequireContext,
} from '../plugins/helper'

Vue.use(Vuex)

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/)
const modules = getRequireContext(requireContext)

export default new Vuex.Store({
  modules,
})
